import { type Role, roles } from '@/modules/auth/roles';

/**
 * `True` if the user has the given role
 */
export const hasRole = (role: Role, userRoles: string[]) => {
  return userRoles.includes(role);
};

/**
 * `True` if the user has at least one of the given roles
 */
export const hasAnyRole = (rolesToCheck: Role[], userRoles: string[]) => {
  return rolesToCheck.some((role) => userRoles.includes(role));
};

/**
 * Roles that grant full access to all routes (recruiter routes included - without '/hm' prefix)
 */
const ELEVATED_ROLES: Role[] = [roles.Recruiter, roles.Admin, roles.SuperAdmin];

/**
 * `True` if the user is a hiring manager without any elevated roles.
 * These users should only access '/hm' routes.
 */
export const isHiringManagerOnly = (userRoles: string[]) => {
  const isHiringManager = hasRole(roles.HiringManager, userRoles);
  const hasElevatedRole = hasAnyRole(ELEVATED_ROLES, userRoles);

  return isHiringManager && !hasElevatedRole;
};
